import { isTop } from '../util';
import { decodeWindowName } from '../childWindowName/index';

/**
 * 通过 window.name 解析是否为 SMP 框架
 * @param res
 */
export const fromSMP = (callback: any = () => true) => {
    if (!isTop()) {
        return decodeWindowName(window.name, callback, () => false);
    } else {
        return false;
    }
};

export default fromSMP;
